import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import LeadStore from '../../store/LeadStore';
import { Close } from '@mui/icons-material';
import { CustomStyledDialog } from '../../utils/helper';

export const MassDeleteDialog = observer(({ toggleMassDeleteDialog, handleToggleMassDeleteDialog, selectedLeads }) => {
  const handleMassDelete = () => {
    LeadStore.deleteLeads(selectedLeads);
  };

  useEffect(() => {
    LeadStore.leadsDeletionStatus && handleToggleMassDeleteDialog();
  }, [LeadStore.leadsDeletionStatus]);

  return (
    <CustomStyledDialog
      open={toggleMassDeleteDialog}
      onClose={(event, reason) => reason !== 'backdropClick' && handleToggleMassDeleteDialog()}
      aria-labelledby="mass-delete-dialog-title"
      aria-describedby="mass-delete-description"
    >
      <DialogTitle>
        <Stack>
          <Typography sx={{ fontWeight: '700' }} component="p">
            Warning
          </Typography>
        </Stack>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleToggleMassDeleteDialog}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <DialogContent dividers>
        <Typography sx={{ fontWeight: '400' }} component="p">
          Are you sure want to delete the selected lead(s)?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleToggleMassDeleteDialog}>
          No
        </Button>
        <Button variant="contained" color="error" onClick={handleMassDelete} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </CustomStyledDialog>
  );
});
